// openEHR RM model — BMM package org.openehr.rm.data_structures
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { LOCATABLE } from "../common/archetyped.ts";
import type { ITEM } from "./representation.ts";

/**
 * Abstract parent class of all data structure types. Includes the \`_as_hierarchy_\` function which can generate the equivalent CEN EN13606 single hierarchy for each subtype's physical representation. For example, the physical representation of an \`ITEM_LIST\` is \`List<ELEMENT>\`; its implementation of \`_as_hierarchy_\` will generate a \`CLUSTER\` containing the set of \`ELEMENT\` nodes from the list.
 */
export abstract class DATA_STRUCTURE extends LOCATABLE {
  /**
   * Hierarchical equivalent of the physical representation of each subtype, compatible with CEN EN 13606 structures.
   * @returns Result value
   */
  as_hierarchy(): ITEM {
    // Abstract method - must be implemented by subclasses (ITEM_TREE, ITEM_LIST, etc.)
    // Each subclass provides its own implementation
    throw new Error("Method as_hierarchy must be implemented by concrete subclass.");
  }
}
